class Milestone {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.milestoneId = data.milestoneId || `MLN${Date.now()}`;
      this.projectId = data.projectId || null;
      this.milestoneName = data.milestoneName || '';
      this.description = data.description || '';
      this.dueDate = data.dueDate || '';
      this.completedDate = data.completedDate || null;
      this.status = data.status || 'Pending';
      this.progress = data.progress || 0;
      this.deliverables = data.deliverables || [];
      this.createdAt = data.createdAt || new Date().toISOString();
    }
  
    getStatusColor() {
      const colors = {
        'Pending': '#f59e0b',
        'In Progress': '#3b82f6',
        'Completed': '#10b981',
        'Delayed': '#ef4444'
      };
      return colors[this.status] || '#6b7280';
    }
  
    isOverdue() {
      if (!this.dueDate || this.status === 'Completed') return false;
      return new Date(this.dueDate) < new Date();
    }
  
    validate() {
      const errors = [];
      if (!this.milestoneName?.trim()) errors.push('Milestone name required');
      if (!this.projectId) errors.push('Project required');
      if (!this.dueDate) errors.push('Due date required');
      return { isValid: errors.length === 0, errors };
    }
  
    toJSON() { return { ...this }; }
    static fromJSON(json) { return new Milestone(json); }
  }
  export default Milestone;